// eslint-disable-next-line import/no-unresolved
import * as NewRelic from 'new-relic-browser';

declare global {
  interface Window {
    // eslint-disable-next-line no-undef
    newrelic: typeof NewRelic;
  }
}

// eslint-disable-next-line import/prefer-default-export
export function addNewRelicCustomAttribute(attributeName: string, attributeValue: string | number): void {
  if (window.newrelic) {
    window.newrelic.setCustomAttribute(attributeName, attributeValue);
  }
}
